import React, { useEffect, useState } from "react";
import { auth, db } from "../../firebase";
import { doc, setDoc } from "firebase/firestore";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { signOut, onAuthStateChanged, updateProfile } from "firebase/auth";
import styleClasses from './css/LoginSignUp.module.scss';
import Popup from "../Popup";

function GoogleConsentPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [userData, setUserData] = useState(null);
  const [authUser, setAuthUser] = useState(null);
  const [loading, setLoading]   = useState(true);
  const [openPopup, setOpenPopup]               = useState(false);
  const [popupTitle, setPopupTitle]             = useState('');
  const [popupFunction, setPopupFunction]       = useState('');
  const [popupButtonText, setPopupButtonText]   = useState('');
  const [buttonLoading5, setButtonLoading5]     = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const uid = queryParams.get("uid");
    const email = queryParams.get("email");
    const name = queryParams.get("name");

    if (!uid || !email || !name) {
      //alert("잘못된 접근입니다.");
      //navigate("/");
      //return;
      setOpenPopup(true);
      setPopupTitle("잘못된 접근입니다.");
      setPopupFunction(() => () => navigate('/'));
      setPopupButtonText('메인으로 이동');
      return;
    }

    setUserData({ uid, email, name });

    // 🔹 Firebase Auth에서 현재 로그인된 사용자 가져오기
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setAuthUser(user);
        // 🔹 URL 파라미터와 현재 로그인된 사용자의 UID 비교
        if (user.uid !== uid) {
          //alert("잘못된 접근입니다.");
          signOut(auth); // ❌ 인증된 사용자 로그아웃
          //navigate("/");
          setOpenPopup(true);
          setPopupTitle("잘못된 접근입니다.");
          setPopupFunction(() => () => navigate('/'));
          setPopupButtonText('메인으로 이동');
          return;
        } else {
          setLoading(false);
        }
      } else {
        //alert("인증되지 않은 접근입니다.");
        //navigate("/");
        setOpenPopup(true);
        setPopupTitle("인증되지 않은 접근입니다.");
        setPopupFunction(() => () => navigate('/'));
        setPopupButtonText('메인으로 이동');
        return;
      }
    });

    return () => unsubscribe(); // 🔥 클린업
  }, [location, navigate]);

  const handleAgree = async () => {
    if (!userData || !authUser || authUser.uid !== userData.uid) return;

    try {
      const { uid, email, name, photoURL } = userData;

      // Firestore에 사용자 정보 저장
      await setDoc(
          doc(db, "users", uid), {
          email,
          name,
          type: "google",
          agree: true,
          status: "active",
          cardslot: 1,
          createdAt: new Date().toISOString(),
          musicard: {}     // 빈 객체로 초기화
        },
        { merge: true }
      );  

      // 추가로 users_data 컬렉션에 동일 UID의 문서를 생성 (필요한 초기 데이터 구성)
      await setDoc(doc(db, "users_data", uid), {
        createdAt: new Date().toISOString(),
      });

      // 추가로 users_logs 컬렉션에 동일 UID의 문서를 생성 (필요한 초기 데이터 구성)
      await setDoc(doc(db, "users_logs", uid), {
        createdAt: new Date().toISOString(),
      });

      // Firebase 인증의 프로필 업데이트 (displayName 및 photoURL)
      await updateProfile(auth.currentUser, {
        displayName: name,
        photoURL: photoURL,
      });

      //alert("회원가입이 완료되었습니다!");
      await signOut(auth);
      //navigate("/login");
      setOpenPopup(true);
      setPopupTitle("회원가입이 완료되었습니다!");
      setPopupFunction(() => () => navigate('/login'));
      setPopupButtonText('재로그인하고 이용하기');

      setTimeout(() => {
        navigate("/login"); // 로그인으로 리디렉션
      }, 5000);
    } catch (error) {
      console.error("사용자 정보 저장 실패:", error.message);
    }
  };

  const handleReject = async () => {
    setOpenPopup(true);
    setPopupTitle("개인정보 동의가 필요합니다. 로그인되지 않습니다.");
    setPopupFunction(() => () => navigate('/login'));
    setPopupButtonText('재로그인하기');
    //alert("개인정보 동의가 필요합니다. 로그인되지 않습니다.");
    await signOut(auth); // ❌ 동의하지 않으면 Firebase 로그아웃
    //navigate("/");

    setTimeout(() => {
      navigate("/login"); // 로그인으로 리디렉션
    }, 5000);
  };

  if (loading) return <p>로딩 중...</p>;

  return (
    <>
      <div className={styleClasses.signUp}>
        <div className={styleClasses.inner}>
          <div className={styleClasses.title}>
            <h1>개인정보처리방침 동의</h1>
          </div>
          <div className={styleClasses.description}>
            <p>Google 계정으로 가입하려면 <br /><Link to="/TermsOfService" style={{ color: "#007BFF", textDecoration: "underline" }}>이용약관</Link> 및 <Link to="/PrivacyPolicy" style={{ color: "#007BFF", textDecoration: "underline" }}>개인정보처리방침</Link>에 동의해야 합니다.</p>
          </div>
          <div className={styleClasses.content}>
            {/* 버튼 영역 */}
            <div className={styleClasses.linkButtons}>
              <div className="commonButton fullWidth">
                <button className="black" onClick={handleAgree}>동의</button>
              </div>
              <div className="commonButton fullWidth">
                <button className="secondary" onClick={handleReject}>취소</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Popup open={ openPopup } setOpenPopup={ setOpenPopup } title={ popupTitle } text='' buttonText={ popupButtonText } buttonFunction={ popupFunction } buttonLoading={ buttonLoading5 } />
    </>
  );
}

export default GoogleConsentPage;
